import { render } from "./FormButton.vue?vue&type=template&id=52a5512b&ts=true"
import script from "./FormButton.vue?vue&type=script&lang=ts"
export * from "./FormButton.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__